// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "common" : chunkId) + "." + {"36":"a1a2ee2318a9358e","76":"5ed9b9e4e57e3b82","331":"3e54dd11a552826a","489":"0e6e32471061546a","995":"efd3fa70ff5bccbc"}[chunkId] + ".js";
};